export const IMAGE_TYPE = {
  svg: 'svg+xml',
}
